import { temAcesso } from '@/shared/auth/temAcesso'

const Apoios = () => import('./Apoios.vue')

export default {
    path: 'apoios',
    name: 'Sgtec_Gerentes_Apoios',
    component: Apoios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('SGTEC-GER-APOIO-00')) {
            next()
        }
    }
}
